import { Navigate, Outlet } from 'react-router';
import { useCurrentUser } from './CurrentUserProvider';

/** Gates every office and yard route behind a session — an unauthenticated visit lands on /login. */
export function RequireAuth() {
  const { state } = useCurrentUser();

  if (state.status === 'loading') return null;
  if (state.status === 'anonymous') return <Navigate to="/login" replace />;

  return <Outlet />;
}
